var version = {
    "name":      "dativery",
    "buildDateCode": "20260616-071309",
    "buildDate": "Tue Jun 16 2026 07:13:09 GMT+0000 (Coordinated Universal Time)",
    "version":   "2.2.0",
    "uiVersion": "2.2.0-20260616-071309",
    "backupUIVersion": "2.2.0-20250519-102244"
}
;
 export default version;